import {environment} from '@environments/environment';

export class HelpdeskUrlConstants {
  public static readonly BASE_URL = environment.helpUrl + '/support/solutions/articles/';
  public static readonly CADCAM = HelpdeskUrlConstants.BASE_URL + '44002333100';
  public static readonly SET_UP_VIBRATION_METER = HelpdeskUrlConstants.BASE_URL + '44002195814-setting-up-the-vibration-meter';
  public static readonly SET_WINDER_IN_MAINTENANCE_MODE = HelpdeskUrlConstants.BASE_URL + '44002195860-setting-the-winder-in-maintenance-mode';
}
